// Partials.js
// This contains shared Views between Client, Patient, Visit, etc.

import React, { useCallback, useEffect, useReducer } from "react";
import { ActivityIndicator, Image, View, Text } from "react-native";
import { FontAwesomeIcon } from "@fortawesome/react-native-fontawesome";
import { faCircleUser } from "@fortawesome/free-regular-svg-icons";
import { faPaw, faClock, faLocationDot, faCalendar, faUserDoctor, faToggleOn, faToggleOff } from "@fortawesome/free-solid-svg-icons";

import Anchor from "components/Partials/Anchor";
import { openSideScreen } from "components/Views/SideScreens/SideScreenLoader";
import { stateReducer } from "components/helpers/stateReducer";


const PatientProfile = ({patientObj})=>{
  const _theme = window.main.theme;
  const openClientSideScreen = ()=>{ openSideScreen("client", {client_id:patientObj.client_id}); };
  return (
    <View id="patient_profile" style={_theme.tileRowNested}>
      <View id="patient_profile_image" style={_theme.containerRow}>
        {!!Number(patientObj.profile_image_id) &&
          <Image source={{ uri:`${window.main.api.url}/api/documents/download/${patientObj.id}/${patientObj.profile_image_id}` }} style={{objectFit:"cover",height:100,width:100,marginRight:20}} />
        }
        {!Number(patientObj.profile_image_id) &&
          <FontAwesomeIcon icon={faPaw} style={{color:_theme.colors.mode.containerBackgroundColor4,height:60,width:60,marginRight:20,borderColor:_theme.colors.mode.containerBackgroundColor4,borderRadius:"50%",borderStyle:"solid",borderWidth:10,padding:10}} />
        }
        <View style={_theme.tiles.seactionHeader}>
          <Text style={_theme.tiles.sectionHeaderKey}>Patient:</Text>
          <Text style={_theme.tiles.sectionHeaderTitle}>{patientObj.title}</Text>
        </View>
      </View>
      <View id="patient_profile_fields" style={{..._theme.tiles.fieldsColumn}}>
        {/* Pinned Custom Fields */}
        {!!patientObj.pinned_fields && !!patientObj.pinned_fields.length && patientObj.pinned_fields.map((fieldObj)=>{
          if (!fieldObj.value) {
          return null;
          }
          return (
            <View key={"fieldObj_"+fieldObj.field_id} style={_theme.tiles.fieldRow}>
              <Text style={_theme.tiles.fieldRowLabel}>{fieldObj.title}</Text>
              <Text style={_theme.tiles.fieldRowValue}>
                {fieldObj.type==="date" && <><Text style={{whiteSpace:"nowrap"}}>{window.main.lib.dateFormat(fieldObj.value.replace(/Z$/,""))}</Text>{"\n"}<Text style={{fontSize:14,whiteSpace:"nowrap"}}>({window.main.lib.sinceDate(fieldObj.value.replace(/Z$/,""))})</Text></>}
                {fieldObj.type==="textarea" && <Text style={{whiteSpace:"pre-wrap"}}>{fieldObj.value}</Text>}
                {fieldObj.type!=="textarea" && fieldObj.type!=="date" && <Text style={{}}>{fieldObj.value}</Text>}
              </Text>
            </View>
          );
        })}
        {/* Regular fields */}
        {!!patientObj.species_name &&
          <View style={_theme.tiles.fieldRow}>
            <Text style={_theme.tiles.fieldRowLabel}>Species</Text>
            <Text style={_theme.tiles.fieldRowValue}>{patientObj.species_name}</Text>
          </View>
        }
        {!!patientObj.breed_name &&
          <View style={_theme.tiles.fieldRow}>
            <Text style={_theme.tiles.fieldRowLabel}>Primary Breed</Text>
            <Text style={_theme.tiles.fieldRowValue}>{patientObj.breed_name}</Text>
          </View>
        }
        {!!patientObj.second_breed_name && patientObj.second_breed_name.trim()!=="" && patientObj.second_breed_name!=="<Please Select>" &&
          <View style={_theme.tiles.fieldRow}>
            <Text style={_theme.tiles.fieldRowLabel}>Secondary Breed</Text>
            <Text style={_theme.tiles.fieldRowValue}>{patientObj.second_breed_name}</Text>
          </View>
        }
        {!!patientObj.gender &&
          <View style={_theme.tiles.fieldRow}>
            <Text style={_theme.tiles.fieldRowLabel}>Gender</Text>
            <Text style={_theme.tiles.fieldRowValue}>
              {patientObj.gender==="male" && "Male"}
              {patientObj.gender==="male-intact" && "Male (Intact)"}
              {patientObj.gender==="neutered" && "Male (Neutered)"}
              {patientObj.gender==="female" && "Female"}
              {patientObj.gender==="female-intact" && "Female (Intact)"}
              {patientObj.gender==="spayed" && "Female (Spayed)"}
              {!(["male","male-intact","neutered","female","female-intact","spayed"].includes(patientObj.gender)) && patientObj.gender}
            </Text>
          </View>
        }
        {!!patientObj.weight &&
          <View style={_theme.tiles.fieldRow}>
            <Text style={_theme.tiles.fieldRowLabel}>Weight</Text>
            <Text style={_theme.tiles.fieldRowValue}>{patientObj.weight}</Text>
          </View>
        }
        {!!patientObj.birth_date &&
          <View style={_theme.tiles.fieldRow}>
            <Text style={_theme.tiles.fieldRowLabel}>Birth Date</Text>
            <Text style={_theme.tiles.fieldRowValue}><Text style={{whiteSpace:"nowrap"}}>{window.main.lib.dateFormat(patientObj.birth_date.replace(/Z$/,""))}</Text>{"\n"}<Text style={{fontSize:14,whiteSpace:"nowrap"}}>({window.main.lib.sinceDate(patientObj.birth_date.replace(/Z$/,"")).replace("ago","old")})</Text></Text>
          </View>
        }
        {/* Custom Fields */}
        {!!patientObj.fields && !!patientObj.fields.length && patientObj.fields.map((fieldObj)=>{
          if (!fieldObj.value) {
          return null;
          }
          return (
          <View key={"fieldObj_"+fieldObj.field_id} style={_theme.tiles.fieldRow}>
            <Text style={_theme.tiles.fieldRowLabel}>{fieldObj.title}</Text>
            <Text style={_theme.tiles.fieldRowValue}>
            {fieldObj.type==="date" && <><Text style={{whiteSpace:"nowrap"}}>{window.main.lib.dateFormat(fieldObj.value.replace(/Z$/,""))}</Text>{"\n"}<Text style={{fontSize:14,whiteSpace:"nowrap"}}>({window.main.lib.sinceDate(fieldObj.value.replace(/Z$/,""))})</Text></>}
            {fieldObj.type==="textarea" && <Text style={{whiteSpace:"pre-wrap"}}>{fieldObj.value}</Text>}
            {fieldObj.type!=="textarea" && fieldObj.type!=="date" && <Text style={{}}>{fieldObj.value}</Text>}
            </Text>
          </View>
          );
        })}
        {/* Regular fields */}
        <View style={_theme.tiles.fieldRow}>
          <Text style={_theme.tiles.fieldRowLabel}>Created</Text>
          <Text style={_theme.tiles.fieldRowValue}><Text style={{whiteSpace:"nowrap"}}>{window.main.lib.dateFormat(patientObj.created_date.replace(/Z$/,""))}</Text>{"\n"}<Text style={{fontSize:14,whiteSpace:"nowrap"}}>({window.main.lib.sinceDate(patientObj.created_date.replace(/Z$/,""))})</Text></Text>
        </View>
        <View style={_theme.tiles.fieldRow}>
          <Text style={_theme.tiles.fieldRowLabel}>Updated</Text>
          <Text style={_theme.tiles.fieldRowValue}><Text style={{whiteSpace:"nowrap"}}>{window.main.lib.dateTimeFormat(patientObj.updated_date.replace(/Z$/,""))}</Text>{"\n"}<Text style={{fontSize:14,whiteSpace:"nowrap"}}>({window.main.lib.sinceDate(patientObj.updated_date.replace(/Z$/,""))})</Text></Text>
        </View>
        <View style={_theme.tiles.fieldRow}>
          <Text style={_theme.tiles.fieldRowLabel}>Tags {/*({patientObj.tags.length})*/}</Text>
          <View style={{..._theme.tiles.fieldRowValue,flexDirection:"row"}}>
            {(!patientObj.tags || !patientObj.tags.length) &&
              <Text style={{..._theme.tiles.fieldRowValue,color:_theme.colors.mode.placeholderTextColor,fontStyle:"italic",fontSize:14,lineHeight:18}}>No tags.</Text>
            }
            {!!patientObj.tags && !!patientObj.tags.length && patientObj.tags.map((tagObj)=>{
              return (
              <Text key={"tagObj_"+tagObj.id} style={{..._theme.tileChip}}>{tagObj.tag}</Text>
              );
            })}
          </View>
        </View>

        <Anchor id="client_link_row" style={{..._theme.tiles.fieldRow,alignItems:"center",alignSelf:"stretch"}} onPress={openClientSideScreen}>
          <View style={{..._theme.containerRow,flexShrink:1,alignItems:"center",color:"inherit"}}>
            {!!Number(patientObj.client_profile_image_id) &&
              <Image source={{ uri:`${window.main.api.url}/api/documents/download/${patientObj.client_id}/${patientObj.client_profile_image_id}` }} style={{height:30,width:30,objectFit:"cover",borderRadius:"50%",marginRight:10}} />
            }
            {!Number(patientObj.client_profile_image_id) &&
              <FontAwesomeIcon icon={faCircleUser} style={{color:_theme.colors.mode.containerBackgroundColor4,height:34,width:34,marginTop:-2,marginBottom:-2,marginLeft:-2,marginRight:10}} />
            }
            <Text style={{..._theme.tiles.fieldRowLabel,flexBasis:"none",fontSize:16,color:"inherit"}}>
              Client: {patientObj.client_title}
            </Text>
          </View>
        </Anchor>

      </View>
    </View>
  );
};


const UpcomingAppointments = ({appointments})=>{
  const _theme = window.main.theme;
  return (
    <View id="client_appointments" style={_theme.tileRowNested}>
      <Text style={_theme.tiles.sectionHeaderTitle}>Upcoming Appointments</Text>
      {(!appointments || !appointments.length) &&
        <View id="client_appointments_row" style={{..._theme.tiles.fieldRow,flexDirection:"column",alignSelf:"stretch"}}>
          <Text style={{..._theme.tiles.fieldRowValue,color:_theme.colors.mode.placeholderTextColor,fontStyle:"italic",fontSize:14,lineHeight:18}}>No upcoming appointments.</Text>
        </View>
      }
      {!!appointments && !!appointments.length && appointments.map((apptObj)=>{
        return (
          <View key={"apptObj_"+apptObj.id} id={"client_appointments_row_"+apptObj.id} style={{..._theme.tiles.fieldRow,flexDirection:"column",alignSelf:"stretch"}}>
            <Text style={{..._theme.tiles.fieldRowLabel,flexGrow:1,flexBasis:"none",flexGrow:0,flexShrink:1,fontSize:16}}>
              {apptObj.title}
            </Text>

            <Text style={{..._theme.tiles.fieldRowValue,flexDirection:"row",whiteSpace:"nowrap",paddingTop:5}}>
              <FontAwesomeIcon icon={faClock} style={{color:_theme.colors.mode.textAccent,height:13,width:13,paddingTop:1.5,paddingRight:8}} />
              <Text style={{..._theme.tiles.fieldRowValue,flexDirection:"column",whiteSpace:"pre-wrap"}}>
              <Text style={{marginRight:12, whiteSpace:"nowrap"}}>{window.main.lib.dateTimeRangeFormat(apptObj.start_date.replace(/Z$/,""), apptObj.end_date.replace(/Z$/,""))}</Text><Text style={{whiteSpace:"nowrap"}}>({"in "+window.main.lib.sinceDate(apptObj.start_date.replace(/Z$/,"")).replace(" ago","")})</Text>
              </Text>
            </Text>
            <Text style={{..._theme.tiles.fieldRowValue,flexDirection:"row",whiteSpace:"nowrap",paddingTop:5}}>
              <FontAwesomeIcon icon={faLocationDot} style={{color:_theme.colors.mode.textAccent,height:14,width:14,paddingTop:1.5,paddingRight:8,marginLeft:-1}} />
              <Text style={{..._theme.tiles.fieldRowValue,flexDirection:"column",whiteSpace:"pre-line"}}>
                {!!apptObj.location.name && apptObj.location.name+"\n"}{apptObj.location.address_1}{!!apptObj.location.address_2 && " "+apptObj.location.address_2}{"\n"}{apptObj.location.city}, {apptObj.location.state} {apptObj.location.zip}
              </Text>
            </Text>
            <Text style={{..._theme.tiles.fieldRowValue,flexDirection:"row",whiteSpace:"nowrap",paddingTop:5}}>
              <FontAwesomeIcon icon={faCalendar} style={{color:_theme.colors.mode.textAccent,height:13,width:13,paddingTop:1.5,paddingRight:8}} />
              <Text style={{..._theme.tiles.fieldRowValue,flexDirection:"column",whiteSpace:"nowrap"}}>
                {apptObj.schedule_name}
              </Text>
            </Text>
            <Text style={{..._theme.tiles.fieldRowValue,flexDirection:"row",whiteSpace:"nowrap",paddingTop:5}}>
              <FontAwesomeIcon icon={faUserDoctor} style={{color:_theme.colors.mode.textAccent,height:13,width:13,paddingTop:1.5,paddingRight:8}} />
              <Text style={{..._theme.tiles.fieldRowValue,flexDirection:"column",whiteSpace:"nowrap"}}>
                {apptObj.appointment_resource_name}
              </Text>
            </Text>
            <Text style={{..._theme.tiles.fieldRowValue,flexDirection:"row",whiteSpace:"nowrap",paddingTop:5,paddingLeft:20}}>
              <Text style={{..._theme.tileChip}}>
                <FontAwesomeIcon icon={faPaw} style={{color:_theme.colors.mode.textAccentDark,height:13,width:13,paddingTop:1,verticalAlign:"top",paddingRight:5}} />
                  {apptObj.patient_title}
              </Text>
            </Text>

          </View>
        );
      })}
    </View>
  );
};


const PatientVaccinations = ({patient_id})=>{
  const [patientViewState, patientViewSetState] = useReducer(stateReducer, {
    patientVaccinations: [],
    patientVaccinationsLoading: true,
    patientVaccFilterActive: true,
  });
  const vaccinationsDataLoad = useCallback(async () => {
    const _stateProps = [{key:"patientVaccinationsLoading", type:"boolean", patientVaccinationsLoading:false}];
    try {
      // Now get additional data
      const _patientVaccs = await window.main.axios.get(window.main.api.getPatientVaccinations.replace("{patient_id}",patient_id));
      if (!!_patientVaccs && !!_patientVaccs.data ) {
        _stateProps.push({ key: "patientVaccinations", type: "array", patientVaccinations: _patientVaccs.data });
      }
      // Update all states at once:
      patientViewSetState(_stateProps);
    } catch (err) {
      console.log("PatientVaccinations > Error:", err);
      const errMsg = window.main.lib.parseErrorMessage(err);
      window.main.lib.setStatusState("Error: "+errMsg);
    } finally {
      patientViewSetState(_stateProps);
    }
  }, []);
  useEffect(() => {
    vaccinationsDataLoad();
  }, []);  // ⬅ Trigger only once on initial page load.
  const toggleVaccActiveAll = ()=>{
	  patientViewSetState({ key:"patientVaccFilterActive", type:"boolean", patientVaccFilterActive:(!patientViewState.patientVaccFilterActive) });
  };
  const _theme = window.main.theme;
  return (
    <View id="patient_vaccinations" style={_theme.tileRowNested}>
      <Text style={{display:"flex",flexDirection:"row",justifyContent:"space-between",alignSelf:"stretch"}}>
      <Text style={_theme.tiles.sectionHeaderTitle}>Current Vaccinations</Text>
      <Anchor style={{flexDirection:"row",justifyContent:"flex-end",paddingLeft:10,paddingTop:10,whiteSpace:"nowrap"}}  onPress={toggleVaccActiveAll}>
        {!!patientViewState.patientVaccFilterActive && <><FontAwesomeIcon icon={faToggleOn} style={{color:_theme.colors.mode.baseDark,height:15,width:15,marginBottom:-2,paddingRight:8}} /><Text style={{color:_theme.colors.mode.baseDark,fontSize:14,display:"inline-block",width:40}}>Active</Text></>}
        {!patientViewState.patientVaccFilterActive && <><FontAwesomeIcon icon={faToggleOff} style={{color:_theme.colors.mode.baseDark,height:15,width:15,marginBottom:-2,paddingRight:8}} /><Text style={{color:_theme.colors.mode.baseDark,fontSize:14,display:"inline-block",width:40}}>All</Text></>}
      </Anchor>
      </Text>
      {!!patientViewState.patientVaccinations && !!patientViewState.patientVaccinations.length && patientViewState.patientVaccinations.map((vaccObj)=>{
        if (!!patientViewState.patientVaccFilterActive && !!vaccObj.is_expired) {
          return null;
        }
        const visit_link = ( !Number(vaccObj.visit_id) ? ()=>{} : ()=>{ openSideScreen("visit", {client_id:vaccObj.client_id, patient_id:vaccObj.id, visit_id:vaccObj.visit_id}); } );
        return (
          <View key={"vaccObj_"+vaccObj.patient_vaccination_id} id={"patient_vaccination_row_"+vaccObj.patient_vaccination_id} style={_theme.tiles.sectionRow}>
            <Text style={{..._theme.tiles.fieldRowLabel,flexGrow:1,flexBasis:"none",flexGrow:0,flexShrink:1,fontSize:16}}>
              {vaccObj.vaccine_name}
            </Text>
            <Text style={{..._theme.tiles.fieldRowValue,flexDirection:"row",marginTop:8,fontSize:15,fontWeight:"700"}}>
              Serial number: {vaccObj.serialnumber}
            </Text>
            <Text style={{..._theme.tiles.fieldRowValue,flexDirection:"row",whiteSpace:"nowrap",marginTop:5}}>
              Administered: {window.main.lib.dateFormat(vaccObj.administered_date.replace(/Z$/,""))}
            </Text>
            <Text style={{..._theme.tiles.fieldRowValue,flexDirection:"row",whiteSpace:"nowrap",marginTop:5,...(!!vaccObj.is_expired?{color:_theme.colors.caution}:{})}}>
              Expiration: {window.main.lib.dateFormat(vaccObj.administered_expiration_date.replace(/Z$/,""))}
            </Text>
            {!!Number(vaccObj.visit_id) &&
              <Anchor style={{..._theme.tiles.fieldRowValue,flexDirection:"row",marginTop:5,maxWidth:"100%"}} onPress={visit_link}>
                <Text style={{..._theme.tiles.fieldRowValue,flexFlow:"none",display:"block",whiteSpace:"nowrap",width:"100%",overflow:"hidden",textOverflow:"ellipsis"}}><Text style={{fontWeight:"600",marginRight:6}}>Visit:</Text>{vaccObj.title}</Text>
              </Anchor>
            }
          </View>
        );
      })}
      {((!patientViewState.patientVaccinations || !patientViewState.patientVaccinations.length) && !patientViewState.patientVaccinationsLoading) &&
        <View id="patient_vaccination_row" style={_theme.tiles.sectionRow}>
          <Text style={{..._theme.tiles.fieldRowValue,color:_theme.colors.mode.placeholderTextColor,fontStyle:"italic",fontSize:14,lineHeight:18}}>No current vaccinations.</Text>
        </View>
      }
      {!window.main.lib.getLoadingState() && (!patientViewState.patientVaccinations || !patientViewState.patientVaccinations.length) && !!patientViewState.patientVaccinationsLoading &&
        <View id="patient_vaccinations_loading" style={{..._theme.tiles.sectionRow,minHeight:50}}>
          <View style={{zIndex:99999,backgroundColor:"rgba(255,255,255,0.7)",top:0,left:0,bottom:0,right:0,position:"absolute"}}>
            <ActivityIndicator size="large" color={_theme.colors.mode.base} style={{marginTop:10}} />
          </View>
        </View>
      }
    </View>
  );
};


const PatientPrescriptions = ({patient_id})=>{
  const [partialState, partialSetState] = useReducer(stateReducer, {
    patientRxs: [],
    patientRxsLoading: true,
  });
  const vaccinationsDataLoad = useCallback(async () => {
    const _stateProps = [{key:"patientRxsLoading", type:"boolean", patientRxsLoading:false}];
    try {
      // Now get additional data
      const _patientRxs = await window.main.axios.get(window.main.api.getPatientPrescriptions.replace("{patient_id}",patient_id));
      if (!!_patientRxs && !!_patientRxs.data ) {
        _stateProps.push({ key: "patientRxs", type: "array", patientRxs: _patientRxs.data });
      }
      // Update all states at once:
      partialSetState(_stateProps);
    } catch (err) {
      console.log("PatientRxs > Error:", err);
      const errMsg = window.main.lib.parseErrorMessage(err);
      window.main.lib.setStatusState("Error: "+errMsg);
    } finally {
      partialSetState(_stateProps);
    }
  }, []);
  useEffect(() => {
    vaccinationsDataLoad();
  }, []);  // ⬅ Trigger only once on initial page load.
  const _theme = window.main.theme;
  return (
    <View id="patient_rxs" style={_theme.tileRowNested}>
      <Text style={_theme.tiles.sectionHeaderTitle}>Recent Prescriptions</Text>
      {!!partialState.patientRxs && !!partialState.patientRxs.length && partialState.patientRxs.map((rxObj)=>{
        return (
          <View key={"rxObj_"+rxObj.rx_id} id={"patient_rx_row_"+rxObj.rx_id} style={_theme.tiles.sectionRow}>
            <Text style={{..._theme.tiles.fieldRowLabel,flexGrow:1,flexBasis:"none",flexGrow:0,flexShrink:1,fontSize:16}}>
              {rxObj.drug}
            </Text>
            <Text style={{..._theme.tiles.fieldRowValue,flexGrow:1,flexDirection:"row",marginTop:8}}>
              <Text style={{marginRight:20,whiteSpace:"nowrap"}}>
                <Text style={{marginRight:6}}>Status:</Text>
                {rxObj.status==="pending" && "Pending"}
                {rxObj.status==="filled" && "Completed"}
                {rxObj.status==="prescribed" && rxObj.method!=="Controlled Script" && "Called-in"}
                {rxObj.status==="prescribed" && rxObj.method==="Controlled Script" && "Prescribed"}
              </Text>
              {rxObj.status==="filled" && <Text style={{whiteSpace:"nowrap"}}>Filled: {window.main.lib.dateFormat(rxObj.updated_date.replace(/Z$/,""))}</Text>}
              {rxObj.status!=="filled" && <Text style={{whiteSpace:"nowrap"}}>Created: {window.main.lib.dateFormat(rxObj.created_date.replace(/Z$/,""))}</Text>}
            </Text>
            <Text style={{..._theme.tiles.fieldRowValue,flexGrow:1,flexDirection:"row",marginTop:5}}>
              <Text style={{marginRight:20,whiteSpace:"nowrap"}}>
                <Text style={{marginRight:6}}>Fulfillment Method:</Text>
                <Text style={{...((rxObj.method==="In-House"||rxObj.method==="Controlled Script")?{fontWeight:800}:{})}}>{rxObj.method}</Text>
              </Text>
              {rxObj.method==="In-House" && <Text style={{whiteSpace:"nowrap"}}>Fulfillment: {rxObj.refill_number}/{rxObj.prescribed_refills+1}</Text>}
              {rxObj.method!=="In-House" && <Text style={{whiteSpace:"nowrap"}}>Refills: {rxObj.prescribed_refills}</Text>}
            </Text>
            {!!rxObj.location_name &&
              <Text style={{..._theme.tiles.fieldRowValue,flexGrow:1,flexDirection:"row",marginTop:5}}>
                <Text style={{marginRight:6}}>Location:</Text> {rxObj.location_name}
              </Text>
            }
          </View>
        );
      })}
      {((!partialState.patientRxs || !partialState.patientRxs.length) && !partialState.patientRxsLoading) &&
        <View id="patient_rx_row" style={_theme.tiles.sectionRow}>
          <Text style={{..._theme.tiles.fieldRowValue,color:_theme.colors.mode.placeholderTextColor,fontStyle:"italic",fontSize:14,lineHeight:18}}>No current vaccinations.</Text>
        </View>
      }
      {!window.main.lib.getLoadingState() && (!partialState.patientRxs || !partialState.patientRxs.length) && !!partialState.patientRxsLoading &&
        <View id="patient_rxs_loading" style={{..._theme.tiles.sectionRow,minHeight:50}}>
          <View style={{zIndex:99999,backgroundColor:"rgba(255,255,255,0.7)",top:0,left:0,bottom:0,right:0,position:"absolute"}}>
            <ActivityIndicator size="large" color={_theme.colors.mode.base} style={{marginTop:10}} />
          </View>
        </View>
      }
    </View>
  );
};


const PatientReminders = ({patient_id})=>{
  const _theme = window.main.theme;
  const [patientViewState, patientViewSetState] = useReducer(stateReducer, {
    patientReminders: [],
    patientRemindersLoading: true,
  });
  const remindersDataLoad = useCallback(async () => {
    const _stateProps = [{key:"patientRemindersLoading", type:"boolean", patientRemindersLoading:false}];
    try {
      // Now get additional data
      const _patientVaccs = await window.main.axios.get(window.main.api.getPatientReminders.replace("{patient_id}",patient_id));
      if (!!_patientVaccs && !!_patientVaccs.data ) {
      _stateProps.push({ key: "patientReminders", type: "array", patientReminders: _patientVaccs.data });
      }
      // Update all states at once:
      patientViewSetState(_stateProps);
    } catch (err) {
      console.log("PatientReminders > Error:", err);
      const errMsg = window.main.lib.parseErrorMessage(err);
      window.main.lib.setStatusState("Error: "+errMsg);
    } finally {
      patientViewSetState(_stateProps);
    }
  }, []);
  useEffect(() => {
	  remindersDataLoad();
  }, []);  // ⬅ Trigger only once on initial page load.
  return (
    <View id="patient_reminders" style={_theme.tileRowNested}>
      <Text style={_theme.tiles.sectionHeaderTitle}>Current Reminders</Text>
      {!!patientViewState.patientReminders && !!patientViewState.patientReminders.length && patientViewState.patientReminders.map((reminderObj)=>{
        if (!!patientViewState.patientVaccFilterActive && !!reminderObj.is_expired) {
          return null;
        }
        return (
          <View key={"reminderObj_"+reminderObj.reminder_id} id={"patient_reminder_row_"+reminderObj.reminder_id} style={_theme.tiles.sectionRow}>
            <Text style={{..._theme.tiles.fieldRowLabel,flexGrow:1,flexBasis:"none",flexGrow:0,flexShrink:1,fontSize:16}}>
              {reminderObj.reminder_type}: {reminderObj.description}
              {reminderObj.is_completed===1 && <Text style={{color:_theme.colors.success,marginLeft:10}}>[COMPLETED]</Text>}
              {reminderObj.is_archived===1 && <Text style={{color:_theme.colors.caution,marginLeft:10}}>[ARCHIVED]</Text>}
              {reminderObj.is_past_due===1 && <Text style={{color:_theme.colors.caution,marginLeft:10}}>[PAST DUE]</Text>}
            </Text>
            <Text style={{..._theme.tiles.fieldRowValue,flexDirection:"row",marginTop:5,fontSize:15}}>
              Due: {window.main.lib.dateFormat(reminderObj.due_date.replace(/Z$/,""))}
            </Text>
          </View>
        );
      })}
      {((!patientViewState.patientReminders || !patientViewState.patientReminders.length) && !patientViewState.patientRemindersLoading) &&
        <View id="patient_reminder_row" style={_theme.tiles.sectionRow}>
          <Text style={{..._theme.tiles.fieldRowValue,color:_theme.colors.mode.placeholderTextColor,fontStyle:"italic",fontSize:14,lineHeight:18}}>No reminders.</Text>
        </View>
      }
      {!window.main.lib.getLoadingState() && (!patientViewState.patientReminders || !patientViewState.patientReminders.length) && !!patientViewState.patientRemindersLoading &&
        <View id="patient_reminders_loading" style={{..._theme.tiles.sectionRow,minHeight:50}}>
          <View style={{zIndex:99999,backgroundColor:"rgba(255,255,255,0.7)",top:0,left:0,bottom:0,right:0,position:"absolute"}}>
            <ActivityIndicator size="large" color={_theme.colors.mode.base} style={{marginTop:10}} />
          </View>
        </View>
      }
    </View>
  );
};


export {
  PatientProfile,
  UpcomingAppointments,
  PatientVaccinations,
  PatientReminders,
  PatientPrescriptions,
};
